import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate,useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
 import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

import axiosInstance from "../../axiosInstance";
 
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useBlogContext } from "../../fetchdata/BlogContext";

const HomeLocation = () => {

  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }
  const {
        
    isLayoutLoading,
    layout,AllHomeProducts,isProducts,IsBlogLoading,AllBlogs
  } = useBlogContext();

const [loading, setloading] = useState(true);

const [Data, setData] = useState([]);
const { slug } = useParams();


const getData = async () => {
  if(slug){
    const modifiedSlug = slug.replace(/-/g, ' '); // This will remove all hyphens

    setloading(true);

    try {
      const { data } = await axiosInstance.get(`/get-catgeory-product?location=${modifiedSlug}`);
      setData(data.categoriesWithProducts || []);
      // Delay the execution of buildScript by 1 secon
      console.log('datadata',data);
    
    }
    catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }
  }
  
};


useEffect(() => {
getData();
window.scrollTo(0, 0);
}, [slug]);

  
const swiperRef = useRef();

const swiperRefLocal = useRef();

const handleMouseEnter = () => {
  swiperRefLocal?.current?.swiper?.autoplay?.stop();
};

const handleMouseLeave = () => {
  swiperRefLocal?.current?.swiper?.autoplay?.start();
};


 


  return (
    <>
      <Header />
 



  
  <section
   className="one-hero-header position-relative d-none"
   style={{
    backgroundImage:
      `url("${layout.slider_img}")`,
    backgroundColor: "#00000047 !important",
    backgroundBlendMode: "multiply"
  }}
 >
   <div className="banner-search py-5">
     <div className="container py-4">
       <div className="row flex-lg-row-reverse align-items-center pb-5 justify-content-center">
         <div className="col-lg-9 col-12">
           <div className="text-center text-white">
             <nav
               aria-label="breadcrumb"
               className="small d-flex justify-content-center text-white"
             >
               <ol className="breadcrumb text-white">
                 <li className="breadcrumb-item">
                   <a href="#" className="text-decoration-none text-white">
                     Home
                   </a>
                 </li>
                 <li
                   className="breadcrumb-item active text-white  text-capitalize"
                   aria-current="page"
                 >
                   {slug.replace(/-/g, ' ') || 'New Delhi'}
                 </li>
               </ol>
             </nav>
             <div className="display-4 fw-bold mb-3">
               Get Services <br />
               Whenever You Need Them.
             </div>
             <p className="lead fw-normal text-white-50 mb-5">
               Find Local Service Professionals Near You!
             </p>
             <div className="row g-4 d-none">
               
               <div className="col-lg-8 col-12 mx-auto">
                 <div className="input-group bg-white rounded-pill shadow-sm">
                   <span
                     className="input-group-text bg-transparent border-0 rounded-0 py-3 px-3"
                     id="search"
                   >
                     <i className="ri-search-line h5 m-0" />
                   </span>
                   <input
                     type="text"
                     className="form-control bg-transparent border-0 rounded-0 py-3 ps-0"
                     placeholder="Search for services"
                     aria-label="Search for services"
                     aria-describedby="search"
                   />
                 </div>
               </div>
             </div>
             <div className="mt-4 mb-5 pb-5 d-none">
               <span className="small py-1 text-decoration-none fw-bold text-white me-2">
                 Popular
               </span>
               <a
                 href="services-list.html"
                 className="small px-2 py-1 rounded-pill bg-white text-decoration-none fw-normal border text-muted me-1"
               >
                 {" "}
                 Cleaning{" "}
               </a>
               <a
                 href="services-list.html"
                 className="small px-2 py-1 rounded-pill bg-white text-decoration-none fw-normal border text-muted me-1"
               >
                 {" "}
                 Washroom{" "}
               </a>
               <a
                 href="services-list.html"
                 className="small px-2 py-1 rounded-pill bg-white text-decoration-none fw-normal border text-muted me-1"
               >
                 {" "}
                 Home Cleaning{" "}
               </a>
               <a
                 href="services-list.html"
                 className="small px-2 py-1 rounded-pill bg-white text-decoration-none fw-normal border text-muted me-1"
               >
                 {" "}
                 Painting{" "}
               </a>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </section>


 <div className="w-100 home-slider h-auto ">
  <img src={layout.slider_img} className="w-100 home-slider home bg-white" />
</div>
  
  <section className="bg-white">
   <div className="container">
     <div className="row">
       <div className="col-12">
         <div className="bg-white border rounded-4 p-2 p-lg-2 all-services position-relative"  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} style={{zIndex:9}} >
         <Swiper
             slidesPerView={1}
             spaceBetween={30}
             pagination={{
               clickable: true,
             }}
             navigation={true}
             breakpoints={{
              300: {
                 slidesPerView: 2,
               },
               640: {
                 slidesPerView: 3,
               },
               768: {
                 slidesPerView: 4,
               },
               1024: {
                 slidesPerView: 5,
               },
             }}
             ref={swiperRefLocal}
             autoplay={{
               delay: 1500,
               pauseOnMouseEnter: true,
             }}
             loop={true}
             modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 ">
 
                   { loading
                    ? Array.from({ length: 5 }).map((_, index) => (
                         <SwiperSlide
                          className="skeleton mb-2 shadow" 
                          style={{
                             height: "60px", 
                            transform:'scale(0.95)'
                          }}
                        ></SwiperSlide>
                     ))
                    : layout.trending_product_banner && (
                      <>

                          {
                      Data.map((category, index) => {
                        return (
                                           <SwiperSlide className=" rounded box">

                                              <Link to={`/${slug}/${category.slug}`} className="text-dark d-flex align-items-center p-2 gap-2 ">
                                                                <div className="text-center p-2">
                                                    <img
                                                  src={category.icon_image}
                                                   alt={category.title} style={{width:50,height:50}}
                                                    className="img-fluid"
                                                />
                                                <p className="small pt-2 m-0">
                                                  {category.title}
                                                </p>
                                                   </div> 
                                              </Link>
                                            </SwiperSlide>
                                       
                                       
                        )})}

                        
                      </>
                    )}
 
   
 
           
            
          </Swiper>
         </div>
       </div>
     </div>
   </div>
 </section>
 
 
 <section className="bg-white py-5">
   <div className="container py-4">
     <div className="row mb-5">
       <div className="col-12">
         <div className="text-center">
           <h2 className="fw-bold">Best Offers</h2>
           <p className="text-muted m-0">
             Hygienic &amp; single-use products &amp; Low-contact services
           </p>
         </div>
       </div>
     </div>
     <div className="w-100" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} >
          
  <Swiper
             slidesPerView={1}
             spaceBetween={30}
             pagination={{
               clickable: true,
             }}
             navigation={true}
             breakpoints={{
               640: {
                 slidesPerView: 1,
               },
               768: {
                 slidesPerView: 3,
               },
               1024: {
                 slidesPerView: 4,
               },
             }}
             ref={swiperRefLocal}
             autoplay={{
               delay: 1500,
               pauseOnMouseEnter: true,
             }}
             loop={true}
             modules={[Pagination, Navigation, Autoplay]} className="pb-4" > 
 
     
     {layout.latest_product_banner && layout.latest_product_banner.length !== 0 &&
   layout.latest_product_banner.map((product, index) => (
       <SwiperSlide  >
         <Link to={`${product.imageUrlInput.replace('{{id}}', slug )}`} className="link-dark">
           <div className="zoom-img">
             <img
              src={product.imageInput} 
               alt=""
               className="img-fluid rounded-4 object-fit-cover" style={{aspectRatio:'1/1'}}
             />
           </div>
           <div className="text-center pt-3">
             <p className="fw-semibold mb-0">{product.imageTITInput}</p>
             <p className="text-muted small m-0">{product.imageParaInput}</p>
           </div>
         </Link>
       </SwiperSlide>
       ))
 }
       </Swiper>
 
           </div>
 
   </div>
 </section>
 
 
 
  {/* Book Now */}
   <section className="bg-white">
     <div className="container">
       <div className="row">
         <div className="col-12"  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} >
           <Swiper   slidesPerView={1}
             spaceBetween={30}
             pagination={{
               clickable: true,
             }}
             navigation={true}
             breakpoints={{
               640: {
                 slidesPerView: 2,
               },
               768: {
                 slidesPerView: 3,
               },
               1024: {
                 slidesPerView: 4,
               },
             }}
             ref={swiperRefLocal}
             autoplay={{
               delay: 1500,
               pauseOnMouseEnter: true,
             }}
             loop={true}
             modules={[Pagination, Navigation, Autoplay]} className="salon-spa-service  pb-4">
            {loading
                    ? Array.from({ length: 4 }).map((_, index) => (
                         <SwiperSlide
                          className="skeleton mb-2 shadow" 
                          style={{
                             height: "60px", 
                            transform:'scale(0.95)'
                          }}
                        ></SwiperSlide>
                     ))
                    : layout.trending_product_carousal && (
                      <>
                        {layout.trending_product_carousal.map((image, index) => (
                         
    <SwiperSlide className="book-item zoom-img px-2">
              <Link to={`${image?.imageUrlInput?.replace('{{id}}', slug )}`}  >
                 <img src={image.imageInput}   alt={image.imageTITInput}  className="img-fluid" />
               </Link>
             </SwiperSlide>
  
                  ))}
                      </>
                    )}
 
 
           
           </Swiper>
         </div>
       </div>
     </div>
   </section>
   {/* Salon Spa and message services */}
 
   
   {
Data.map((category, index) => {
  return (
 
 <section className="bg-white pt-5 d-none" key={index}>
     {/* <div className="container pt-4">
       <div className="row mb-5">
         <div className="col-12">
           <div className="text-center">
             <h2 className="fw-bold">Our {category.title} Services</h2>
             <p className="text-muted m-0">
               Each listing is designed to be clear and concise, providing customers
             </p>
           </div>
         </div>
       </div>

         <div className="row">
         <div className="col-12" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} >
           <Swiper className="slider-five pb-4" slidesPerView={1}
             spaceBetween={30}
             pagination={{
               clickable: true,
             }}
             navigation={true}
             breakpoints={{
               640: {
                 slidesPerView: 2,
               },
               768: {
                 slidesPerView: 4,
               },
               1024: {
                 slidesPerView: 5,
               },
             }}
             ref={swiperRefLocal}
             autoplay={{
               delay: 1500,
               pauseOnMouseEnter: true,
             }}
             loop={true}
             modules={[Pagination, Navigation, Autoplay]} >
              
          
               
                 {category?.products.map((product, index) => {
                

                return (

             <SwiperSlide className="service-item px-2">
                <Link to={`/product/${product.slug}`} className="link-dark">
                 <div className="zoom-img">
                   <img
                     src={product.pImage}
                     alt={product.title}
                     className="img-fluid rounded"
                   />
                 </div>
                 <div className="text-center pt-3">
                   <p className="fw-semibold mb-0">  {product.title} </p>
                   <p className="text-muted small m-0">Service starts at @ <b className="text-black"> ₹{product.salePrice} </b></p>
                 </div>
               </Link>
             </SwiperSlide>
             )
              }) }

           </Swiper>
         </div>

 

{category?.products.length > 4 && 
  <div className="row">
          <div className="col-md-12">
            <div className="text-center wow fadeInUp" data-wow-delay="0.2s">
              <a href="/services" className="btn btn-dark">
                View All
                <i className="ti ti-arrow-right ms-2" />
              </a>
            </div>
          </div>
        </div>
}
        
      </div>
      </div> */}
    </section>
  
  
)})
} 

  
   {/* Customer safety is our priority */}
   <div className="py-5 bg-white">
     <div className="container py-4">
       <div className="row mb-5">
         <div className="col-12">
           <div className="text-center">
             <h2 className="fw-bold">Customer safety is our priority</h2>
             <p className="text-muted m-0">
               What customer are saying about our safety standards
             </p>
           </div>
         </div>
       </div>
       <div className="row">
         <div className="col-lg-12 "      onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} >
           <Swiper  slidesPerView={1}
             spaceBetween={30}
             pagination={{
               clickable: true,
             }}
             navigation={true}
             breakpoints={{
               640: {
                 slidesPerView: 1,
               },
               768: {
                 slidesPerView: 2,
               },
               1024: {
                 slidesPerView: 3,
               },
             }}
             ref={swiperRefLocal}
             autoplay={{
               delay: 1500,
               pauseOnMouseEnter: true,
             }}
             loop={true}
             modules={[Pagination, Navigation, Autoplay]}
              className="slider-three pb-4">
 
  
 {layout.latest_product_carousal && layout.latest_product_carousal.length !== 0 &&
   layout.latest_product_carousal.map((product, index) => (
             <SwiperSlide className="item px-2">
               <div className="bg-light p-4 rounded-3 overflow-hidden review-item">
                 <div className="d-flex align-items-center mb-4">
                   
                      <img
               src={product.imageInput}
                     className="img-fluid rounded-circle shadow-sm"
                     alt="Reviewer"
                   />
                   <div className="ms-3">
                     <h6 className="mb-0 fw-bold text-dark"> {product.imageTITInput} </h6>
                     <p className="text-black-50 small mb-0">
                       Best Service
                     </p>
                     <div className="rating">
                       <span className="ri-star-s-fill text-warning" />
                       <span className="ri-star-s-fill text-warning" />
                       <span className="ri-star-s-fill text-warning" />
                       <span className="ri-star-s-fill text-warning" />
                       <span className="ri-star-s-fill text-warning" />
                     </div>
                   </div>
                 </div>
                 <p className="m-0">
                 {product.imageUrlInput}
                 </p>
               </div>
             </SwiperSlide>
            ))
 }
           </Swiper>
         </div>
       </div>
     </div>
   </div>
   {/* End Verify Offcanvas */}
   <div className="pt-5 bg-light">
     <div className="container">
       <div className="row align-items-center">
         <div className="col-lg-6 pe-lg-5 me-auto pb-5">
           <h1 className="fw-bold mb-3 text-body lh-sm">
                {layout.collection_heading}
           </h1>
           <p className="text-muted">
        {layout.collection_paragraph}
           </p>
           <form className="row g-3 mb-5">
             <div className="col-md-auto col-12">
               <Link to={layout.collection_url} className="btn btn-dark btn-lg px-4">
                 Book Now
               </Link>
             </div>
           </form>
           {/* <a class="me-2" href="#"><img src="/assets/img/site/google.png" class="img-fluid app-icon" alt="#" loading="lazy"></a>
             <a href="#"><img src="/assets/img/site/apple.png" class="img-fluid app-icon" alt="#" loading="lazy"></a> */}
         </div>
         <div className="col-lg-5 ps-lg-5">
           <img
              src={layout.collection_img}
             className="img-fluid"
             alt="#"
             loading="lazy"
           />
         </div>
       </div>
     </div>
   </div>

   <div className="container py-4 ">
     <Swiper
             slidesPerView={1}
             spaceBetween={30}
             pagination={{
               clickable: true,
             }}
             navigation={true}
             breakpoints={{
              300: {
                 slidesPerView: 4,
               },
               640: {
                 slidesPerView: 5,
               },
               768: {
                 slidesPerView: 8,
               },
               1024: {
                 slidesPerView: 8,
               },
             }}
             ref={swiperRefLocal}
             autoplay={{
               delay: 1500,
               pauseOnMouseEnter: true,
             }}
             loop={true}
             modules={[Pagination, Navigation, Autoplay]} className="logo-section pb-0 ">
              
            
             {layout.home_slider && layout.home_slider.map((image, index) => (
                         
             <SwiperSlide className="d-flex align-items-center h-100">
                  <img src={image}   alt={image}  className="img-fluid" />
              </SwiperSlide>
  
                  ))}

 </Swiper>
</div>

   {/* Most Popular Cities */}
   
  
 
      <Footer />
    </>
  );
};

export default HomeLocation;
